var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-drawer",
    {
      staticStyle: {
        height: "100%",
        overflow: "auto",
        "padding-bottom": "53px"
      },
      attrs: {
        title: _vm.title,
        maskClosable: false,
        width: _vm.drawerWidth,
        placement: "right",
        closable: true,
        visible: _vm.visible
      },
      on: { close: _vm.handleCancel }
    },
    [
      _c("template", { slot: "title" }, [
        _c("div", { staticStyle: { width: "100%" } }, [
          _c("span", [_vm._v(_vm._s(_vm.title))]),
          _c(
            "span",
            {
              staticStyle: {
                display: "inline-block",
                width: "calc(100% - 51px)",
                "padding-right": "10px",
                "text-align": "right"
              }
            },
            [
              _c("a-button", {
                staticStyle: { height: "20px", width: "20px", border: "0px" },
                attrs: { icon: "appstore" },
                on: { click: _vm.toggleScreen }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules }
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["user.column.userName"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "username"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      autocomplete: "new-password",
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["user.column.userName"],
                      disabled: !!_vm.model.id,
                      maxLength: _vm.maxLength
                    },
                    model: {
                      value: _vm.model.username,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "username", $$v)
                      },
                      expression: "model.username"
                    }
                  })
                ],
                1
              ),
              !_vm.model.id
                ? [
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: _vm.language["user.column.password"],
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol,
                          prop: "password"
                        }
                      },
                      [
                        _c("a-input-password", {
                          attrs: {
                            autocomplete: "new-password",
                            type: "password",
                            placeholder:
                              _vm.language["common.pleaseInput"] +
                              _vm.language["user.column.password"],
                            maxLength: _vm.maxLength,
                            disabled: _vm.disableSubmit
                          },
                          model: {
                            value: _vm.model.password,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "password", $$v)
                            },
                            expression: "model.password"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "a-form-model-item",
                      {
                        attrs: {
                          label: _vm.language["column.confirmPassword"],
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol,
                          prop: "confirmpassword",
                          disabled: _vm.disableSubmit
                        }
                      },
                      [
                        _c("a-input-password", {
                          attrs: {
                            type: "password",
                            placeholder:
                              _vm.language["warning.passwordAgainRequired"],
                            maxLength: _vm.maxLength,
                            disabled: _vm.disableSubmit
                          },
                          on: { blur: _vm.handleConfirmBlur },
                          model: {
                            value: _vm.model.confirmpassword,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "confirmpassword", $$v)
                            },
                            expression: "model.confirmpassword"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["user.column.realname"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "realname"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["user.column.realname"],
                      maxLength: _vm.maxLength,
                      disabled: _vm.disableSubmit
                    },
                    model: {
                      value: _vm.model.realname,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "realname", $$v)
                      },
                      expression: "model.realname"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["employee.column.englishName"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["employee.column.englishName"],
                      maxLength: 40
                    },
                    model: {
                      value: _vm.model.englishName,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "englishName", $$v)
                      },
                      expression: "model.englishName"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["user.column.userType"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "userType"
                  }
                },
                [
                  _c("j-dict-select-tag", {
                    attrs: {
                      type: "radio",
                      "trigger-change": true,
                      dictCode: "user_type_emp",
                      disabled:
                        _vm.disableSubmit ||
                        !!_vm.model.id ||
                        _vm.userTypeDisable
                    },
                    on: { change: _vm.onChangeUserType },
                    model: {
                      value: _vm.model.userType,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "userType", $$v)
                      },
                      expression: "model.userType"
                    }
                  })
                ],
                1
              ),
              _vm.model.userType === "nonemployee"
                ? _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: _vm.language["common.company"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder:
                            _vm.language["common.pleaseInput"] +
                            _vm.language["common.company"],
                          maxLength: 100,
                          disabled: _vm.disableSubmit
                        },
                        model: {
                          value: _vm.model.companyName,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "companyName", $$v)
                          },
                          expression: "model.companyName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !(_vm.model.userType === "nonemployee")
                ? _c(
                    "div",
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["user.column.workNo"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "workNo"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["user.column.workNo"],
                              maxLength: _vm.maxLength,
                              disabled: _vm.disableSubmit
                            },
                            model: {
                              value: _vm.model.workNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "workNo", $$v)
                              },
                              expression: "model.workNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.roleLoading && !!_vm.model.id
                ? _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.roleDisabled,
                          expression: "!roleDisabled"
                        }
                      ],
                      attrs: {
                        label: _vm.language["column.userRole.choose"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("j-select-role-for-apllication", {
                        attrs: {
                          disabled: _vm.disableSubmit,
                          appId: _vm.apps ? _vm.apps.join(",") : "",
                          option: _vm.rolesOptions,
                          listUrl: _vm.roleListUrl
                        },
                        model: {
                          value: _vm.model.selectedroles,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "selectedroles", $$v)
                          },
                          expression: "model.selectedroles"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.departDisabled &&
              !(_vm.model.userType === "nonemployee") &&
              !!_vm.model.id
                ? _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: _vm.language["user.column.deportChoose"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "search",
                                disabled: _vm.disableSubmit
                              },
                              on: { click: _vm.toSelectDeport }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.language["PlatForm.employee.chooseDepart"]
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._l(_vm.selectedApps, function(item, index) {
                        return !_vm.boo && item.selectedDepartNames
                          ? _c("div", { key: index, attrs: { value: item } }, [
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "900" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item.applicationNameLanguage ||
                                        item.applicationName
                                    )
                                  )
                                ]
                              ),
                              _vm._v(
                                " : " +
                                  _vm._s(item.selectedDepartNames) +
                                  "\n            "
                              )
                            ])
                          : _vm._e()
                      }),
                      _vm._l(_vm.newselectedApps, function(item, index) {
                        return _vm.boo && item.selectedDepartNames
                          ? _c("div", { key: index, attrs: { value: item } }, [
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "900" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item.applicationNameLanguage ||
                                        item.applicationName
                                    )
                                  )
                                ]
                              ),
                              _vm._v(
                                " : " +
                                  _vm._s(item.selectedDepartNames) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["user.column.userIdentity"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c(
                    "a-radio-group",
                    {
                      attrs: { disabled: _vm.disableSubmit },
                      on: { change: _vm.identityChange },
                      model: {
                        value: _vm.model.userIdentity,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "userIdentity", $$v)
                        },
                        expression: "model.userIdentity"
                      }
                    },
                    [
                      _c("a-radio", { attrs: { value: 1 } }, [
                        _vm._v(_vm._s(_vm.language["system.user.ordinaryUser"]))
                      ]),
                      _c("a-radio", { attrs: { value: 2 } }, [
                        _vm._v(_vm._s(_vm.language["system.user.superiors"]))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.departIdShow == true
                ? _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: _vm.language["system.user.chargeDeport"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "search",
                                disabled: _vm.disableSubmit
                              },
                              on: { click: _vm.toSelectChargeDeport }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.language["PlatForm.employee.chooseDepart"]
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._l(_vm.chargeDeparts, function(item, index) {
                        return _c(
                          "div",
                          { key: index, attrs: { value: item } },
                          [
                            _c(
                              "span",
                              { staticStyle: { "font-weight": "900" } },
                              [_vm._v(_vm._s(item.applicationName))]
                            ),
                            _vm._v(
                              " : " +
                                _vm._s(item.selectedDepartNames) +
                                "\n          "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["user.column.Avatar"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("j-image-upload", {
                    staticClass: "avatar-uploader",
                    attrs: {
                      text: _vm.language["common.uploadButton"],
                      "upload-source": _vm.uploadSource,
                      disabled: _vm.disableSubmit
                    },
                    model: {
                      value: _vm.model.avatar,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "avatar", $$v)
                      },
                      expression: "model.avatar"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["user.column.birthday"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: _vm.language["warning.birthdayRequired"],
                      format: _vm.dateFormat,
                      disabled: _vm.disableSubmit,
                      getCalendarContainer: function(node) {
                        return node.parentNode
                      }
                    },
                    model: {
                      value: _vm.model.birthday,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "birthday", $$v)
                      },
                      expression: "model.birthday"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["user.column.sex"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c(
                    "a-select",
                    {
                      attrs: {
                        disabled: _vm.disableSubmit,
                        placeholder: _vm.language["warning.genderRequired"],
                        getPopupContainer: function(target) {
                          return target.parentNode
                        }
                      },
                      model: {
                        value: _vm.model.sex,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "sex", $$v)
                        },
                        expression: "model.sex"
                      }
                    },
                    [
                      _c("a-select-option", { attrs: { value: 1 } }, [
                        _vm._v(_vm._s(_vm.language["common.sex.man"]))
                      ]),
                      _c("a-select-option", { attrs: { value: 2 } }, [
                        _vm._v(_vm._s(_vm.language["common.sex.woman"]))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              !(_vm.model.userType === "nonemployee")
                ? _c(
                    "div",
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["column.mailbox"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "email"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["column.mailbox"],
                              maxLength: 50,
                              disabled: _vm.disableSubmit
                            },
                            model: {
                              value: _vm.model.email,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "email", $$v)
                              },
                              expression: "model.email"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.model.userType === "nonemployee"
                ? _c(
                    "div",
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["column.mailbox"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["column.mailbox"],
                              maxLength: 50,
                              disabled: _vm.disableSubmit
                            },
                            model: {
                              value: _vm.model.email,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "email", $$v)
                              },
                              expression: "model.email"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["user.column.phone"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "phone"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["user.column.phone"],
                      maxLength: _vm.maxLength,
                      disabled: _vm.disableSubmit
                    },
                    model: {
                      value: _vm.model.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "phone", $$v)
                      },
                      expression: "model.phone"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  staticStyle: { "margin-bottom": "30px" },
                  attrs: {
                    label: _vm.language["column.Landline"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["warning.landlineNumberRequired"],
                      maxLength: _vm.maxLength,
                      disabled: _vm.disableSubmit
                    },
                    model: {
                      value: _vm.model.telephone,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "telephone", $$v)
                      },
                      expression: "model.telephone"
                    }
                  })
                ],
                1
              ),
              !(_vm.model.userType === "nonemployee")
                ? _c(
                    "a-form-model-item",
                    {
                      staticStyle: { "margin-bottom": "30px" },
                      attrs: {
                        label:
                          _vm.language["PlatForm.employee.columns.costCode"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: { maxLength: _vm.maxLength, disabled: true },
                        model: {
                          value: _vm.employee.costCode,
                          callback: function($$v) {
                            _vm.$set(_vm.employee, "costCode", $$v)
                          },
                          expression: "employee.costCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !(_vm.model.userType === "nonemployee")
                ? _c(
                    "a-form-model-item",
                    {
                      staticStyle: { "margin-bottom": "30px" },
                      attrs: {
                        label:
                          _vm.language["PlatForm.employee.columns.factoryName"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: { maxLength: _vm.maxLength, disabled: true },
                        model: {
                          value: _vm.employee.factoryName,
                          callback: function($$v) {
                            _vm.$set(_vm.employee, "factoryName", $$v)
                          },
                          expression: "employee.factoryName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !(_vm.model.userType === "nonemployee")
                ? _c(
                    "a-form-model-item",
                    {
                      staticStyle: { "margin-bottom": "30px" },
                      attrs: {
                        label:
                          _vm.language["PlatForm.employee.columns.empClass"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: { maxLength: _vm.maxLength, disabled: true },
                        model: {
                          value: _vm.employee.empClass,
                          callback: function($$v) {
                            _vm.$set(_vm.employee, "empClass", $$v)
                          },
                          expression: "employee.empClass"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !(_vm.model.userType === "nonemployee")
                ? _c(
                    "a-form-model-item",
                    {
                      staticStyle: { "margin-bottom": "30px" },
                      attrs: {
                        label:
                          _vm.language["PlatForm.employee.columns.companyName"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: { maxLength: _vm.maxLength, disabled: true },
                        model: {
                          value: _vm.employee.companyName,
                          callback: function($$v) {
                            _vm.$set(_vm.employee, "companyName", $$v)
                          },
                          expression: "employee.companyName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label:
                          _vm.language[
                            "PlatForm.employee.columns.selectedAppids"
                          ],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("j-multi-select-tag", {
                        attrs: {
                          maxTagCount: 20,
                          options: _vm.appsOptions,
                          disabled: true
                        },
                        model: {
                          value: _vm.model.selectedAppids,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "selectedAppids", $$v)
                          },
                          expression: "model.selectedAppids"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("a-col", {
                staticStyle: { height: "50px" },
                attrs: { span: 24 }
              })
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.disableSubmit,
              expression: "!disableSubmit"
            }
          ],
          staticClass: "drawer-bootom-button"
        },
        [
          _c(
            "a-popconfirm",
            {
              attrs: {
                title: _vm.language["message.giveUpEditing"],
                okText: _vm.language["common.determineButton"],
                cancelText: _vm.language["common.cancel"]
              },
              on: { confirm: _vm.handleCancel }
            },
            [
              _c("a-button", { staticStyle: { "margin-right": ".8rem" } }, [
                _vm._v(_vm._s(_vm.language["common.cancel"]))
              ])
            ],
            1
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.confirmLoading },
              on: { click: _vm.handleSubmit }
            },
            [_vm._v(_vm._s(_vm.language["common.submitButton"]))]
          )
        ],
        1
      ),
      _c("j-select-depart-modal-by-application", {
        ref: "departSelectModalByApplication",
        on: { ok: _vm.loadselectDeport }
      }),
      _c("j-select-depart-modal-by-application", {
        ref: "chargeDepartSelectModalByApplication",
        on: { ok: _vm.loadselectChargeDeport }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }